<template>
    <div>

        <b-modal ref="modal-rrhh-discount" :title="$t(getTitleModal)" modal-class="modal-primary" hide-footer
            @hidden="$emit('hideModal')" size="md" no-close-on-backdrop no-close-on-esc>

            <ValidationObserver ref="ref-validation-adicional-bono">

                <b-row class="border-right">

                    <b-col md="12" class="mb-2">
                        <div class="d-flex my-1">
                            <span class="text-warning">
                                {{ modalData.personal }}
                            </span>
                        </div>
                        <div class="d-flex flex-column flex-lg-row gap-2">
                            <span>Periodo: {{ modalData.periodo }}</span>
                        </div>
                        <div class="d-flex gap-x-3">
                            <span class="text-warning">Fecha Inicio: {{ modalData.fecha_inicio | globalDate }}</span>
                            <span class="text-warning">Fecha Fin: {{ modalData.fecha_fin | globalDate }}</span>
                        </div>
                    </b-col>

                    <b-col lg="6" md="6">
                        <validation-provider v-slot="{ errors }" name="monto" rules="required">
                            <b-form-group :label="'Monto'" label-for="total" :state="errors[0] ? false : null">
                                <money id="total" v-model="form.monto" v-bind="moneyConfig"
                                    class="form-control w-100 form-control-md" />
                            </b-form-group>
                        </validation-provider>
                    </b-col>


                    <!-- Observation Approve -->
                    <b-col md="12" lg="12">
                        <ValidationProvider v-slot="{ errors }" rules="required|max:400" name="comentario">
                            <b-form-group :label="'Comentario'" label-for="comentario"
                                :state="errors[0] ? false : null">
                                <b-form-textarea id="comentario" v-model="form.comentario" rows="3"
                                    :class="{ 'border-danger': errors[0] }" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>

            </ValidationObserver>

            <!-- </div> -->
            <div class="text-center mt-1">
                <b-button v-if="modalData.id == null" @click="registrarAdicionalBono"
                    variant="outline-success">REGISTRAR</b-button>
                <b-button v-else variant="outline-warning" @click="actualizarAdicionalBono">ACTUALIZAR</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import modalMixin from "@/mixins/modal";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import DiscountsService from "@/views/commons/discounts/services/discounts.service.js";
import BonoService from "@/views/rrhh/views/payroll/components/bonos/service/bono.service.js";

export default {
    mixins: [modalMixin],
    components: {},
    props: {
        modalData: {
            type: Object,
            require: true,
        },
    },
    data() {
        return {
            moneyConfig: {
                decimal: ".",
                thousands: ",",
                prefix: "S/.",
                precision: 2,
                masked: false,
            },
            form: {
                id: null,
                monto: 0,
                comentario: null
            },

            showModalMotivoAdelanto: false,
            suppressEvents: true, // Evita que se recalculen las fracciones al iniciar el modal
        };
    },
    mounted() {
        this.toggleModal("modal-rrhh-discount");
    },
    async created() {
        try {
            this.addPreloader();

            if (this.modalData.id != null) {
                this.form.id = this.modalData.id;

                await this.getAdicionalBono();
            }
        } catch (error) {
            console.log(error);
        } finally {
            this.removePreloader();
            this.suppressEvents = false; // Permite el cálculo de fracciones después de la carga inicial
        }
    },
    computed: {
        ...mapGetters({
            currentUser: "auth/currentUser",
        }),
        getTitleModal() {
            if (this.modalData.id != null) return "EDITAR ADICIONAL";
            return "REGISTRAR ADICIONAL";
        },
    },
    methods: {

        async getAdicionalBono() {
            try {
                const params = { bono_detalle_id: this.modalData.id };
                const { data } = await BonoService.getAdicionalBono(params);

                console.log(data);
                this.form.monto = data[0].monto;
                this.form.comentario = data[0].comentario;

            } catch (error) {
                console.log(error);
            } finally {
                // this.removePreloader();
            }
        },

        async registrarAdicionalBono() {
            try {
                console.log("modalData: ", this.modalData)
                const result = await this.$refs["ref-validation-adicional-bono"].validate();
                if (result) {
                    const confirm = await this.showConfirmSwal();
                    if (confirm.isConfirmed) {
                        this.addPreloader();

                        const { data } = await BonoService.registrarAdicionalBono({
                            id: null,
                            detalle_bono_id: this.modalData.detalle_bono_id,
                            monto: this.form.monto,
                            comentario: this.form.comentario
                        });
                        console.log("data: ", data);
                        this.$toast({
                            component: ToastificationContent,
                            position: "top-right",
                            props: {
                                title: this.$t(data.message),
                                icon: "CoffeeIcon",
                                variant: "success",
                                text: this.$t(data.message),
                            },
                        });
                        this.$emit("refresh", true);
                    }
                }
            } catch (error) {
                this.showToastError(error?.response?.data?.message);
            } finally {
                this.removePreloader();
            }
        },

        async actualizarAdicionalBono() {
            try {
                const result = await this.$refs["ref-validation-adicional-bono"].validate();
                if (result) {
                    const confirm = await this.showConfirmSwal();
                    if (confirm.isConfirmed) {
                        this.addPreloader();

                        const { data } = await BonoService.actualizarAdicionalBono({
                            id: this.modalData.id,
                            detalle_bono_id: this.modalData.detalle_bono_id,
                            monto: this.form.monto,
                            comentario: this.form.comentario
                        });

                        console.log("data: ", data);

                        this.$toast({
                            component: ToastificationContent,
                            position: "top-right",
                            props: {
                                title: this.$t(data.message),
                                icon: "CoffeeIcon",
                                variant: "success",
                                text: this.$t(data.message),
                            },
                        });
                        this.$emit("refresh", true);
                    }
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.removePreloader();
            }
        },

    },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
